export default "__VITE_ASSET__PS9McoGm__"